import React from 'react';

// Bump when the wording changes: it is saved on each new user
// (consent_text_version) as the record of which text they agreed to.
export const CONSENT_TEXT_VERSION = '2026-11-01';

/** Fields sent with a signup request so the server can record the consent. */
export const consentFields = () => ({
  consent_text_version: CONSENT_TEXT_VERSION,
  consent_page: typeof window !== 'undefined' ? window.location.href.slice(0, 500) : null,
});

/** Same fields as a query string, for the Google redirect sign-in. */
export const consentQuery = () => new URLSearchParams(
  Object.entries(consentFields()).filter(([, v]) => v),
).toString();

/**
 * Consent line shown directly under the Sign up and Google buttons. Signing up
 * is the agreement, so there is no extra click.
 */
const SignupConsentLine = ({ verb = 'signing up', className = '' }) => (
  <p className={`text-sm text-slate-500 text-center leading-snug ${className}`} data-testid="signup-consent-line">
    By {verb}, you agree to the{' '}
    <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" className="underline hover:text-slate-700">
      Privacy Policy
    </a>{' '}
    and to receive updates from gradnext on WhatsApp and email. You can opt out anytime.
  </p>
);

export default SignupConsentLine;
